<div
  class="flex items-center gap-3 rounded-lg border p-3"
  [ngClass]="isOverdue ? 'border-red-200 bg-red-50' : 'border-slate-100 bg-slate-50'"
>
  <div
    class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border"
    [ngClass]="isFired ? 'border-amber-200 bg-amber-100 text-amber-600' : 'border-slate-200 bg-white text-amber-500'"
  >
    <app-icon class="!h-5 !w-5 !text-[20px] !leading-5">{{ isFired ? 'notifications_active' : 'notifications' }}</app-icon>
  </div>

  <div class="min-w-0 flex-1">
    <div class="flex flex-wrap items-center gap-2">
      <span class="truncate text-base font-bold text-slate-900">{{ event.x_data?.title }}</span>
      @if (isFired) {
        <span class="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-700">
          {{ 'reminder_fired' | translate }}
        </span>
      }
    </div>
    <div class="mt-0.5 flex min-w-0 items-center gap-1.5">
      <app-avatar
        size="16px"
        [title]="getAuthorName()"
        [url]="getAuthorAvatarUrl()"
        [isPhotoGallery]="false"
      />
      <span class="truncate text-sm text-slate-400">{{ getAuthorName() }}</span>
    </div>

    @if (event.x_data?.text) {
      <div class="mt-1 text-sm text-slate-600" [innerHTML]="event.x_data.text"></div>
    }

    @if (!isFired && event.x_data?.reminders?.length) {
      <div class="mt-2 flex flex-wrap items-center gap-2 text-sm text-slate-400">
        <span>{{ 'reminder_notify' | translate }}:</span>
        @for (reminderAt of event.x_data.reminders; track reminderAt) {
          <span class="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1 text-sm font-medium text-slate-600">
            <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-slate-400">event</app-icon>
            {{ reminderAt | date: 'd MMM HH:mm' }}
          </span>
        }
      </div>
    }
  </div>

  <div class="flex shrink-0 flex-col items-end gap-2">
    @if (!isFired) {
      <button
        type="button"
        class="!mb-2 flex h-6 w-6 items-center justify-center rounded text-slate-400 hover:bg-slate-100 hover:text-slate-600"
        [attr.aria-label]="'reminder_actions' | translate"
        [cdkMenuTriggerFor]="actionsMenu"
      >
        <app-icon class="!h-4 !w-4 !text-[16px] !leading-4">more_vert</app-icon>
      </button>
    }

    @if (isFired) {
      @if (event.x_data?.reminder_offset || event.x_data?.due_at) {
        <span class="text-sm text-slate-400">{{ (event.x_data.reminder_offset || event.x_data.due_at) | date: 'd MMM HH:mm' }}</span>
      }
    } @else {
      @if (event.x_data?.due_at) {
        <span class="text-sm font-medium" [ngClass]="isOverdue ? 'text-red-500' : 'text-slate-400'">{{ event.x_data.due_at | date: 'd MMM HH:mm' }}</span>
      }

      @if (event.x_data?.status === CARD_REMINDER_STATUS.CANCELLED) {
        <span class="text-sm font-semibold text-slate-400">{{ 'reminder_status_cancelled' | translate }}</span>
      } @else if (event.x_data?.status === CARD_REMINDER_STATUS.DONE) {
        @if (canPrefill) {
          <app-button
            btnType="stroked"
            [attr.aria-label]="'reminder_repeat' | translate"
            (click)="onRepeatClick()"
          >
            {{ 'reminder_repeat' | translate }}
          </app-button>
        }
      } @else {
        <app-button
          [disabled]="updatingStatus"
          [attr.aria-label]="'reminder_done' | translate"
          (onChangeClick)="toggleDone()"
        >
          {{ 'reminder_done' | translate }}
        </app-button>
      }
    }
  </div>
</div>

<ng-template #actionsMenu>
  <div cdkMenu class="min-w-40 rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg">
    @if (canPrefill) {
      <button
        type="button"
        cdkMenuItem
        class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-50"
        (click)="onEditClick()"
      >
        <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-slate-400">edit</app-icon>
        {{ 'reminder_edit_action' | translate }}
      </button>
    }
    <button
      type="button"
      cdkMenuItem
      class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50"
      (click)="onCancelClick()"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-red-500">cancel</app-icon>
      {{ 'reminder_cancel_action' | translate }}
    </button>
  </div>
</ng-template>
